import {Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core';
import {SafeHtml} from "../../pipes/SafeHtml";

@Component({
    selector: 'app-iframe-modal',
    standalone: true,
    imports: [
        SafeHtml
    ],
    templateUrl: './iframe-modal.component.html',
    styleUrl: './iframe-modal.component.scss'
})
export class IframeModalComponent {
  @Input() visible = false;        // Управляет показом/скрытием   // Адрес iframe
  @Output() closed = new EventEmitter<void>();
  @Input() content?: any;   // iframe

  close() {
    this.closed.emit();
  }

  onBackdropClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  protected readonly TemplateRef = TemplateRef;

  @ViewChild('contentContainer', { static: true }) contentContainer!: ElementRef;

  ngAfterViewInit() {
    this.applyIframeDefaults();
  }

  ngAfterViewChecked() {
    this.applyIframeDefaults();
  }

  private applyIframeDefaults() {
    const iframes = this.contentContainer.nativeElement.querySelectorAll('iframe');
    iframes.forEach((iframe: HTMLIFrameElement) => {
      if (!iframe.hasAttribute('width')) {
        iframe.width = '800';   // дефолтная ширина
      }
      if (!iframe.hasAttribute('height')) {
        iframe.height = '600';  // дефолтная высота
      }
    });
  }
}
